import { fetchContacts } from 'common/api/v1/searchi';

import {
    FETCH_CONTACTS,
    FETCH_CONTACTS_FAILURE,
    FETCH_CONTACTS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (q, page = 1, branchOfficeId) =>
    (dispatch) => {
        if (!q) return;

        dispatch(actions[FETCH_CONTACTS]());

        fetchContacts({ q, page, branchOfficeId }).then(
            (response) => {
                dispatch(actions[FETCH_CONTACTS_SUCCESS](response.data));
            },
            (error) => {
                dispatch(
                    actions[FETCH_CONTACTS_FAILURE](error?.response?.data),
                );
            },
        );
    };
